Object.defineProperty(exports, '__esModule', { value: true });

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var errors = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message, key) {
        var _this = _super.call(this, key ? message + " in " + key : message) || this;
        _this.key = key;
        _this.name = 'ValidationError';
        Object.setPrototypeOf(_this, ValidationError.prototype);
        return _this;
    }
    return ValidationError;
}(Error));
exports.ValidationError = ValidationError;
});

unwrapExports(errors);
var errors_1 = errors.ValidationError;

var contract = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

function Contract() {
    var runtypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        runtypes[_i] = arguments[_i];
    }
    var lastIndex = runtypes.length - 1;
    var argTypes = runtypes.slice(0, lastIndex);
    var returnType = runtypes[lastIndex];
    return {
        enforce: function (f) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args.length < argTypes.length)
                throw new errors.ValidationError("Expected " + argTypes.length + " arguments but only received " + args.length);
            for (var i = 0; i < argTypes.length; i++)
                argTypes[i].check(args[i]);
            return returnType.check(f.apply(void 0, args));
        }; },
    };
}
exports.Contract = Contract;
});

unwrapExports(contract);
var contract_1 = contract.Contract;

var asynccontract = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

function AsyncContract() {
    var runtypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        runtypes[_i] = arguments[_i];
    }
    var lastIndex = runtypes.length - 1;
    var argTypes = runtypes.slice(0, lastIndex);
    var returnType = runtypes[lastIndex];
    return {
        enforce: function (f) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args.length < argTypes.length)
                throw new errors.ValidationError("Expected " + argTypes.length + " arguments but only received " + args.length);
            for (var i = 0; i < argTypes.length; i++)
                argTypes[i].check(args[i]);
            var returnedPromise = f.apply(void 0, args);
            if (!(returnedPromise instanceof Promise))
                throw new errors.ValidationError("Expected function to return a promise, but instead got " + returnedPromise);
            return returnedPromise.then(returnType.check);
        }; },
    };
}
exports.AsyncContract = AsyncContract;
});

unwrapExports(asynccontract);
var asynccontract_1 = asynccontract.AsyncContract;

var match_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
function match() {
    var cases = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        cases[_i] = arguments[_i];
    }
    return function (x) {
        for (var _i = 0, cases_1 = cases; _i < cases_1.length; _i++) {
            var _a = cases_1[_i], T = _a[0], f = _a[1];
            if (T.guard(x))
                return f(x);
        }
        throw new Error('No alternatives were matched');
    };
}
exports.match = match;
});

unwrapExports(match_1);
var match_2 = match_1.match;

var show_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
var show = function (needsParens, circular) { return function (refl) {
    var parenthesize = function (s) { return (needsParens ? "(" + s + ")" : s); };
    if (circular.has(refl)) {
        return parenthesize("CIRCULAR " + refl.tag);
    }
    circular.add(refl);
    try {
        switch (refl.tag) {
            // Primitive types
            case 'unknown':
            case 'never':
            case 'void':
            case 'boolean':
            case 'number':
            case 'string':
            case 'symbol':
            case 'function':
                return refl.tag;
            // Complex types
            case 'literal': {
                var value = refl.value;
                return typeof value === 'string' ? "\"" + value + "\"" : String(value);
            }
            case 'array':
                return "" + readonlyTag(refl) + show(true, circular)(refl.element) + "[]";
            case 'dictionary':
                return "{ [_: " + refl.key + "]: " + show(false, circular)(refl.value) + " }";
            case 'record': {
                var keys = Object.keys(refl.fields);
                return keys.length
                    ? "{ " + keys
                        .map(function (k) {
                        return "" + readonlyTag(refl) + k + partialTag(refl) + ": " + show(false, circular)(refl.fields[k]) + ";";
                    })
                        .join(' ') + " }"
                    : '{}';
            }
            case 'tuple':
                return "[" + refl.components.map(show(false, circular)).join(', ') + "]";
            case 'union':
                return parenthesize("" + refl.alternatives.map(show(true, circular)).join(' | '));
            case 'intersect':
                return parenthesize("" + refl.intersectees.map(show(true, circular)).join(' & '));
            case 'constraint':
                return refl.name || show(needsParens, circular)(refl.underlying);
            case 'instanceof':
                var name_1 = refl.ctor.name;
                return "InstanceOf<" + name_1 + ">";
            case 'brand':
                return show(needsParens, circular)(refl.entity);
        }
    }
    finally {
        circular.delete(refl);
    }
    throw Error('impossible');
}; };
exports.default = show(false, new Set());
function partialTag(_a) {
    var isPartial = _a.isPartial;
    return isPartial ? '?' : '';
}
function readonlyTag(_a) {
    var isReadonly = _a.isReadonly;
    return isReadonly ? 'readonly ' : '';
}
});

unwrapExports(show_1);

var runtype = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



function create(validate, A) {
    A.check = check;
    A.assert = check;
    A._innerValidate = function (value, visited) {
        if (visited.has(value, A))
            return { success: true, value: value };
        return validate(value, visited);
    };
    A.validate = function (value) { return A._innerValidate(value, VisitedState()); };
    A.guard = guard;
    A.Or = Or;
    A.And = And;
    A.withConstraint = withConstraint;
    A.withGuard = withGuard;
    A.withBrand = withBrand;
    A.reflect = A;
    A.toString = function () { return "Runtype<" + show_1.default(A) + ">"; };
    return A;
    function check(x) {
        var validated = A.validate(x);
        if (validated.success) {
            return validated.value;
        }
        throw new errors.ValidationError(validated.message, validated.key);
    }
    function guard(x) {
        return A.validate(x).success;
    }
    function Or(B) {
        return lib.Union(A, B);
    }
    function And(B) {
        return lib.Intersect(A, B);
    }
    function withConstraint(constraint, options) {
        return lib.Constraint(A, constraint, options);
    }
    function withGuard(guard, options) {
        return lib.Constraint(A, guard, options);
    }
    function withBrand(B) {
        return lib.Brand(B, A);
    }
}
exports.create = create;
function innerValidate(targetType, value, visited) {
    return targetType._innerValidate(value, visited);
}
exports.innerValidate = innerValidate;
function VisitedState() {
    var members = new WeakMap();
    var add = function (candidate, type) {
        if (candidate === null || !(typeof candidate === 'object'))
            return;
        var typeSet = members.get(candidate);
        members.set(candidate, typeSet ? typeSet.set(type, true) : new WeakMap().set(type, true));
    };
    var has = function (candidate, type) {
        var typeSet = members.get(candidate);
        var value = (typeSet && typeSet.get(type)) || false;
        add(candidate, type);
        return value;
    };
    return { has: has };
}
});

unwrapExports(runtype);
var runtype_1 = runtype.create;
var runtype_2 = runtype.innerValidate;

var unknown = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Validates anything, but provides no new type information about it.
 */
exports.Unknown = runtype.create(function (value) { return ({ success: true, value: value }); }, { tag: 'unknown' });
});

unwrapExports(unknown);
var unknown_1 = unknown.Unknown;

var never = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Validates nothing (unknown fails).
 */
exports.Never = runtype.create(function (value) { return ({
    success: false,
    message: "Expected nothing, but was " + (value === null ? value : typeof value),
}); }, { tag: 'never' });
});

unwrapExports(never);
var never_1 = never.Never;

var _void = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Void is an alias for Unknown
 *
 * @deprecated Please use Unknown instead
 */
exports.Void = unknown.Unknown;
});

unwrapExports(_void);
var _void_1 = _void.Void;

var literal_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Be aware of an Array of Symbols `[Symbol()]` which would throw "TypeError: Cannot convert a Symbol value to a string"
 */
function literal(value) {
    return Array.isArray(value) ? String(value.map(String)) : String(value);
}
/**
 * Construct a runtype for a type literal.
 */
function Literal(valueBase) {
    return runtype.create(function (value) {
        return value === valueBase
            ? { success: true, value: value }
            : {
                success: false,
                message: "Expected literal '" + literal(valueBase) + "', but was '" + literal(value) + "'",
            };
    }, { tag: 'literal', value: valueBase });
}
exports.Literal = Literal;
/**
 * An alias for Literal(undefined).
 */
exports.Undefined = Literal(undefined);
/**
 * An alias for Literal(null).
 */
exports.Null = Literal(null);
});

unwrapExports(literal_1);
var literal_2 = literal_1.Literal;
var literal_3 = literal_1.Undefined;
var literal_4 = literal_1.Null;

var boolean_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Validates that a value is a boolean.
 */
exports.Boolean = runtype.create(function (value) {
    return typeof value === 'boolean'
        ? { success: true, value: value }
        : {
            success: false,
            message: "Expected boolean, but was " + (value === null ? value : typeof value),
        };
}, { tag: 'boolean' });
});

unwrapExports(boolean_1);
var boolean_2 = boolean_1.Boolean;

var number = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Validates that a value is a number.
 */
exports.Number = runtype.create(function (value) {
    return typeof value === 'number'
        ? { success: true, value: value }
        : {
            success: false,
            message: "Expected number, but was " + (value === null ? value : typeof value),
        };
}, { tag: 'number' });
});

unwrapExports(number);
var number_1 = number.Number;

var string = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Validates that a value is a string.
 */
exports.String = runtype.create(function (value) {
    return typeof value === 'string'
        ? { success: true, value: value }
        : {
            success: false,
            message: "Expected string, but was " + (value === null ? value : typeof value),
        };
}, { tag: 'string' });
});

unwrapExports(string);
var string_1 = string.String;

var symbol = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Validates that a value is a symbol.
 */
var Sym = runtype.create(function (value) {
    return typeof value === 'symbol'
        ? { success: true, value: value }
        : {
            success: false,
            message: "Expected symbol, but was " + (value === null ? value : typeof value),
        };
}, { tag: 'symbol' });
exports.Symbol = Sym;
});

unwrapExports(symbol);
var symbol_1 = symbol.Symbol;

var array = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Construct an array runtype from a runtype for its elements.
 */
function InternalArr(element, isReadonly) {
    return withExtraModifierFuncs(runtype.create(function (xs, visited) {
        if (!Array.isArray(xs)) {
            return {
                success: false,
                message: "Expected array, but was " + (xs === null ? xs : typeof xs),
            };
        }
        for (var _i = 0, xs_1 = xs; _i < xs_1.length; _i++) {
            var x = xs_1[_i];
            var validated = runtype.innerValidate(element, x, visited);
            if (!validated.success) {
                return {
                    success: false,
                    message: validated.message,
                    key: validated.key ? "[" + xs.indexOf(x) + "]." + validated.key : "[" + xs.indexOf(x) + "]",
                };
            }
        }
        return { success: true, value: xs };
    }, { tag: 'array', isReadonly: isReadonly, element: element }));
}
function Arr(element) {
    return InternalArr(element, false);
}
exports.Array = Arr;
function withExtraModifierFuncs(A) {
    A.asReadonly = asReadonly;
    return A;
    function asReadonly() {
        return InternalArr(A.element, true);
    }
}
});

unwrapExports(array);
var array_1 = array.Array;

var tuple = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



function Tuple() {
    var components = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        components[_i] = arguments[_i];
    }
    return runtype.create(function (x, visited) {
        var validated = runtype.innerValidate(array.Array(unknown.Unknown), x, visited);
        if (!validated.success) {
            return {
                success: false,
                message: "Expected tuple to be an array:\u00A0" + validated.message,
                key: validated.key,
            };
        }
        if (validated.value.length !== components.length) {
            return {
                success: false,
                message: "Expected an array of length " + components.length + ", but was " + validated.value.length,
            };
        }
        for (var i = 0; i < components.length; i++) {
            var validatedComponent = runtype.innerValidate(components[i], validated.value[i], visited);
            if (!validatedComponent.success) {
                return {
                    success: false,
                    message: validatedComponent.message,
                    key: validatedComponent.key ? "[" + i + "]." + validatedComponent.key : "[" + i + "]",
                };
            }
        }
        return { success: true, value: x };
    }, { tag: 'tuple', components: components });
}
exports.Tuple = Tuple;
});

unwrapExports(tuple);
var tuple_1 = tuple.Tuple;

var util = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
// Type guard to determine if an object has a given key
// If this feature gets implemented, we can use `in` instead: https://github.com/Microsoft/TypeScript/issues/10485
function hasKey(k, o) {
    return typeof o === 'object' && k in o;
}
exports.hasKey = hasKey;
});

unwrapExports(util);
var util_1 = util.hasKey;

var record = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



/**
 * Construct a record runtype from runtypes for its values.
 */
function InternalRecord(fields, isPartial, isReadonly) {
    return withExtraModifierFuncs(runtype.create(function (x, visited) {
        if (x === null || x === undefined) {
            var a = runtype.create(function (_x) { return ({ success: true, value: _x }); }, { tag: 'record', fields: fields });
            return { success: false, message: "Expected " + show_1.default(a) + ", but was " + x };
        }
        for (var key in fields) {
            if (!isPartial || (util.hasKey(key, x) && x[key] !== undefined)) {
                var value = isPartial || util.hasKey(key, x) ? x[key] : undefined;
                var validated = runtype.innerValidate(fields[key], value, visited);
                if (!validated.success) {
                    return {
                        success: false,
                        message: validated.message,
                        key: validated.key ? key + "." + validated.key : key,
                    };
                }
            }
        }
        return { success: true, value: x };
    }, { tag: 'record', isPartial: isPartial, isReadonly: isReadonly, fields: fields }));
}
exports.InternalRecord = InternalRecord;
function Record(fields) {
    return InternalRecord(fields, false, false);
}
exports.Record = Record;
function Partial(fields) {
    return InternalRecord(fields, true, false);
}
exports.Partial = Partial;
function withExtraModifierFuncs(A) {
    A.asPartial = asPartial;
    A.asReadonly = asReadonly;
    return A;
    function asPartial() {
        return InternalRecord(A.fields, true, A.isReadonly);
    }
    function asReadonly() {
        return InternalRecord(A.fields, A.isPartial, true);
    }
}
});

unwrapExports(record);
var record_1 = record.InternalRecord;
var record_2 = record.Record;
var record_3 = record.Partial;

var dictionary = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


function Dictionary(value, key) {
    if (key === void 0) { key = 'string'; }
    return runtype.create(function (x, visited) {
        if (x === null || x === undefined) {
            var a = runtype.create(x, { tag: 'dictionary', key: key, value: value });
            return { success: false, message: "Expected " + show_1.default(a) + ", but was " + x };
        }
        if (typeof x !== 'object') {
            var a = runtype.create(x, { tag: 'dictionary', key: key, value: value });
            return { success: false, message: "Expected " + show_1.default(a.reflect) + ", but was " + typeof x };
        }
        if (Object.getPrototypeOf(x) !== Object.prototype) {
            if (!Array.isArray(x)) {
                var a = runtype.create(x, { tag: 'dictionary', key: key, value: value });
                return {
                    success: false,
                    message: "Expected " + show_1.default(a.reflect) + ", but was " + Object.getPrototypeOf(x),
                };
            }
            else if (key === 'string')
                return { success: false, message: 'Expected dictionary, but was array' };
        }
        for (var k in x) {
            // Object keys are unknown strings
            if (key === 'number') {
                if (isNaN(+k))
                    return {
                        success: false,
                        message: 'Expected dictionary key to be a number, but was string',
                    };
            }
            var validated = runtype.innerValidate(value, x[k], visited);
            if (!validated.success) {
                return {
                    success: false,
                    message: validated.message,
                    key: validated.key ? k + "." + validated.key : k,
                };
            }
        }
        return { success: true, value: x };
    }, { tag: 'dictionary', key: key, value: value });
}
exports.Dictionary = Dictionary;
});

unwrapExports(dictionary);
var dictionary_1 = dictionary.Dictionary;

var union = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



function Union() {
    var alternatives = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        alternatives[_i] = arguments[_i];
    }
    var match = function () {
        var cases = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            cases[_i] = arguments[_i];
        }
        return function (x) {
            for (var i = 0; i < alternatives.length; i++) {
                if (alternatives[i].guard(x)) {
                    return cases[i](x);
                }
            }
        };
    };
    return runtype.create(function (value, visited) {
        var commonLiteralFields = {};
        for (var _i = 0, alternatives_1 = alternatives; _i < alternatives_1.length; _i++) {
            var alternative = alternatives_1[_i];
            if (alternative.reflect.tag === 'record') {
                var _loop_1 = function (fieldName) {
                    var field = alternative.reflect.fields[fieldName];
                    if (field.tag === 'literal') {
                        if (commonLiteralFields[fieldName]) {
                            if (commonLiteralFields[fieldName].every(function (value) { return value !== field.value; })) {
                                commonLiteralFields[fieldName].push(field.value);
                            }
                        }
                        else {
                            commonLiteralFields[fieldName] = [field.value];
                        }
                    }
                };
                for (var fieldName in alternative.reflect.fields) {
                    _loop_1(fieldName);
                }
            }
        }
        for (var fieldName in commonLiteralFields) {
            if (commonLiteralFields[fieldName].length === alternatives.length) {
                for (var _a = 0, alternatives_2 = alternatives; _a < alternatives_2.length; _a++) {
                    var alternative = alternatives_2[_a];
                    if (alternative.reflect.tag === 'record') {
                        var field = alternative.reflect.fields[fieldName];
                        if (field.tag === 'literal' &&
                            util.hasKey(fieldName, value) &&
                            value[fieldName] === field.value) {
                            return runtype.innerValidate(alternative, value, visited);
                        }
                    }
                }
            }
        }
        for (var _b = 0, alternatives_3 = alternatives; _b < alternatives_3.length; _b++) {
            var targetType = alternatives_3[_b];
            if (runtype.innerValidate(targetType, value, visited).success) {
                return { success: true, value: value };
            }
        }
        var a = runtype.create(value, { tag: 'union', alternatives: alternatives });
        return {
            success: false,
            message: "Expected " + show_1.default(a) + ", but was " + (value === null ? value : typeof value),
        };
    }, { tag: 'union', alternatives: alternatives, match: match });
}
exports.Union = Union;
});

unwrapExports(union);
var union_1 = union.Union;

var intersect = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

function Intersect() {
    var intersectees = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        intersectees[_i] = arguments[_i];
    }
    return runtype.create(function (value, visited) {
        for (var _i = 0, intersectees_1 = intersectees; _i < intersectees_1.length; _i++) {
            var targetType = intersectees_1[_i];
            var validated = runtype.innerValidate(targetType, value, visited);
            if (!validated.success) {
                return validated;
            }
        }
        return { success: true, value: value };
    }, { tag: 'intersect', intersectees: intersectees });
}
exports.Intersect = Intersect;
});

unwrapExports(intersect);
var intersect_1 = intersect.Intersect;

var _function = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Construct a runtype for functions.
 */
exports.Function = runtype.create(function (value) {
    return typeof value === 'function'
        ? { success: true, value: value }
        : {
            success: false,
            message: "Expected function, but was " + (value === null ? value : typeof value),
        };
}, { tag: 'function' });
});

unwrapExports(_function);
var _function_1 = _function.Function;

var _instanceof = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

function InstanceOf(ctor) {
    return runtype.create(function (value) {
        return value instanceof ctor
            ? { success: true, value: value }
            : {
                success: false,
                message: "Expected " + ctor.name + ", but was " + (value === null ? value : typeof value),
            };
    }, { tag: 'instanceof', ctor: ctor });
}
exports.InstanceOf = InstanceOf;
});

unwrapExports(_instanceof);
var _instanceof_1 = _instanceof.InstanceOf;

var lazy = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Construct a possibly-recursive Runtype.
 */
function Lazy(delayed) {
    var data = {
        get tag() {
            return getWrapped()['tag'];
        },
    };
    var cached;
    function getWrapped() {
        if (!cached) {
            cached = delayed();
            for (var k in cached)
                if (k !== 'tag')
                    data[k] = cached[k];
        }
        return cached;
    }
    return runtype.create(function (x) {
        return getWrapped().validate(x);
    }, data);
}
exports.Lazy = Lazy;
});

unwrapExports(lazy);
var lazy_1 = lazy.Lazy;

var constraint = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



function Constraint(underlying, constraint, options) {
    return runtype.create(function (value) {
        var name = options && options.name;
        var validated = underlying.validate(value);
        if (!validated.success) {
            return validated;
        }
        var result = constraint(validated.value);
        if (string.String.guard(result))
            return { success: false, message: result };
        else if (!result)
            return { success: false, message: "Failed " + (name || 'constraint') + " check" };
        return { success: true, value: validated.value };
    }, {
        tag: 'constraint',
        underlying: underlying,
        constraint: constraint,
        name: options && options.name,
        args: options && options.args,
    });
}
exports.Constraint = Constraint;
exports.Guard = function (guard, options) { return unknown.Unknown.withGuard(guard, options); };
});

unwrapExports(constraint);
var constraint_1 = constraint.Constraint;
var constraint_2 = constraint.Guard;

var brand = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.RuntypeName = Symbol('RuntypeName');
function Brand(brand, entity) {
    return runtype.create(function (value) {
        var validated = entity.validate(value);
        return validated.success
            ? { success: true, value: validated.value }
            : validated;
    }, {
        tag: 'brand',
        brand: brand,
        entity: entity,
    });
}
exports.Brand = Brand;
});

unwrapExports(brand);
var brand_1 = brand.RuntypeName;
var brand_2 = brand.Brand;

var decorator = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

var prototypes = new WeakMap();
/**
 * A parameter decorator. Explicitly mark the parameter as checked on every method call in combination with `@checked` method decorator. The number of `@check` params must be the same as the number of provided runtypes into `@checked`.\
 * Usage:
 * ```ts
 * @checked(Runtype1, Runtype3)
 * method(@check p1: Static1, p2: number, @check p3: Static3) { ... }
 * ```
 */
function check(target, propertyKey, parameterIndex) {
    var prototype = prototypes.get(target) || new Map();
    prototypes.set(target, prototype);
    var validParameterIndices = prototype.get(propertyKey) || [];
    prototype.set(propertyKey, validParameterIndices);
    validParameterIndices.push(parameterIndex);
}
exports.check = check;
function getValidParameterIndices(target, propertyKey, runtypeCount) {
    var prototype = prototypes.get(target);
    var validParameterIndices = prototype && prototype.get(propertyKey);
    if (validParameterIndices) {
        // used with `@check` parameter decorator
        return validParameterIndices;
    }
    var indices = [];
    for (var i = 0; i < runtypeCount; i++) {
        indices.push(i);
    }
    return indices;
}
/**
 * A method decorator. Takes runtypes as arguments which correspond to the ones of the actual method.
 *
 * Usually, the number of provided runtypes must be _**the same as**_ or _**less than**_ the actual parameters.
 *
 * If you explicitly mark which parameter shall be checked using `@check` parameter decorator, the number of `@check` parameters must be _**the same as**_ the runtypes provided into `@checked`.
 *
 * Usage:
 * ```ts
 * @checked(Runtype1, Runtype2)
 * method1(param1: Static1, param2: Static2, param3: any) {
 *   ...
 * }
 *
 * @checked(Runtype1, Runtype3)
 * method2(@check param1: Static1, param2: any, @check param3: Static3) {
 *   ...
 * }
 * ```
 */
function checked() {
    var runtypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        runtypes[_i] = arguments[_i];
    }
    if (runtypes.length === 0) {
        throw new Error('No runtype provided to `@checked`. Please remove the decorator.');
    }
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        var methodId = (target.name || target.constructor.name + '.prototype') +
            (typeof propertyKey === 'string' ? "[\"" + propertyKey + "\"]" : "[" + String(propertyKey) + "]");
        var validParameterIndices = getValidParameterIndices(target, propertyKey, runtypes.length);
        if (validParameterIndices.length !== runtypes.length) {
            throw new Error('Number of `@checked` runtypes and @check parameters not matched.');
        }
        if (validParameterIndices.length > method.length) {
            throw new Error('Number of `@checked` runtypes exceeds actual parameter length.');
        }
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            runtypes.forEach(function (type, typeIndex) {
                var parameterIndex = validParameterIndices[typeIndex];
                var validated = type.validate(args[parameterIndex]);
                if (!validated.success) {
                    throw new errors.ValidationError(methodId + ", argument #" + parameterIndex + ": " + validated.message, validated.key);
                }
            });
            return method.apply(this, args);
        };
    };
}
exports.checked = checked;
});

unwrapExports(decorator);
var decorator_1 = decorator.check;
var decorator_2 = decorator.checked;

var lib = createCommonjsModule(function (module, exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(contract);
__export(asynccontract);
__export(match_1);
__export(errors);
__export(unknown);
__export(never);
__export(_void);

exports.Literal = literal_1.Literal;
exports.Undefined = literal_1.Undefined;
exports.Null = literal_1.Null;
__export(boolean_1);
__export(number);
__export(string);
__export(symbol);
__export(array);
__export(tuple);
__export(record);
__export(dictionary);
__export(union);
__export(intersect);
__export(_function);

exports.InstanceOf = _instanceof.InstanceOf;
__export(lazy);
__export(constraint);

exports.Brand = brand.Brand;
__export(decorator);
});

unwrapExports(lib);
var lib_1 = lib.Record;
var lib_2 = lib.Partial;
var lib_3 = lib.Number;
var lib_4 = lib.String;
var lib_5 = lib.Array;
var lib_6 = lib.Static;
var lib_7 = lib.Union;
var lib_8 = lib.Unknown;
var lib_9 = lib.Boolean;
var lib_10 = lib.Literal;
var lib_11 = lib.Undefined;
var lib_12 = lib.Null;
var lib_13 = lib.InstanceOf;
var lib_14 = lib.Brand;

const AceTimestamp = lib_7(lib_13(Date), lib_4.withConstraint((s) => Date.parse(s) !== NaN));
const EditorLocation = lib_1({
    row: lib_3,
    column: lib_3,
});
const compareEditorLocations = (first, second) => first.column === second.column && first.row === second.row;
const Complete = lib_1({
    type: lib_10("complete"),
    timestamp: AceTimestamp,
    focused: lib_9,
    value: lib_4,
    selection: lib_1({
        start: EditorLocation,
        end: EditorLocation,
    }),
    cursor: EditorLocation,
    scroll: lib_1({
        top: lib_3,
        left: lib_3,
    }),
});
const getComplete = (editor) => Complete.check({
    type: "complete",
    timestamp: new Date(),
    focused: editor.isFocused(),
    value: editor.getValue(),
    selection: editor.selection.getRange(),
    cursor: editor.selection.getCursor(),
    scroll: {
        top: editor.renderer.getScrollTop(),
        left: editor.renderer.getScrollLeft(),
    },
});
const applyComplete = (editor, complete, valueOnly = false) => {
    if (editor.getValue() !== complete.value) {
        safeChangeValue(editor, complete.value);
    }
    if (valueOnly) {
        return;
    }
    const { row, column } = complete.cursor;
    editor.selection.moveCursorTo(row, column);
    const { start, end } = complete.selection;
    editor.selection.setSelectionRange({
        start: { row: start.row, column: start.column },
        end: { row: end.row, column: end.column },
    });
    const { top, left } = complete.scroll;
    editor.renderer.scrollToY(top);
    editor.renderer.scrollToX(left);
};
const Delta = lib_1({
    type: lib_10("delta"),
    timestamp: AceTimestamp,
    focused: lib_9,
    start: EditorLocation,
    end: EditorLocation,
    action: lib_7(lib_10("insert"), lib_10("remove")),
    lines: lib_5(lib_4),
}).And(lib_2({
    id: lib_3,
}));
const applyDelta = (editor, delta) => editor.session.getDocument().applyDelta(delta);
const Selection = lib_1({
    start: EditorLocation,
    end: EditorLocation,
});
const compareSelections = (first, second) => compareEditorLocations(first.start, second.start) && compareEditorLocations(first.end, second.end);
const selectionIsEmpty = (selection) => selection.start.column === selection.end.column && selection.end.row === selection.end.row;
const SelectionChange = lib_1({
    type: lib_10("selectionchange"),
    timestamp: AceTimestamp,
    focused: lib_9,
    start: EditorLocation,
    end: EditorLocation,
});
const applySelectionChange = (editor, selectionChange) => editor.selection.setSelectionRange(selectionChange);
const CursorChange = lib_1({
    type: lib_10("cursorchange"),
    timestamp: AceTimestamp,
    focused: lib_9,
    location: EditorLocation,
});
const applyCursorChange = (editor, cursorChange) => editor.selection.moveCursorTo(cursorChange.location.row, cursorChange.location.column);
const ScrollPosition = lib_1({
    top: lib_3,
    left: lib_3,
});
const ScrollChange = lib_1({
    type: lib_10("scrollchange"),
    timestamp: AceTimestamp,
    focused: lib_9,
    top: lib_3,
    left: lib_3,
});
const applyScrollChange = (editor, scrollChange) => {
    editor.renderer.scrollToY(scrollChange.top);
    editor.renderer.scrollToX(scrollChange.left);
};
const ExternalChange = lib_1({
    type: lib_10("external"),
    timestamp: AceTimestamp,
});
const AceRecord = lib_7(Complete, Delta, SelectionChange, CursorChange, ScrollChange, ExternalChange);
const applyAceRecord = (editor, aceRecord) => {
    if (Complete.guard(aceRecord)) {
        applyComplete(editor, aceRecord);
    }
    else if (Delta.guard(aceRecord)) {
        applyDelta(editor, aceRecord);
    }
    else if (SelectionChange.guard(aceRecord)) {
        applySelectionChange(editor, aceRecord);
    }
    else if (CursorChange.guard(aceRecord)) {
        applyCursorChange(editor, aceRecord);
    }
    else if (ScrollChange.guard(aceRecord)) {
        applyScrollChange(editor, aceRecord);
    }
};
const deserializeAceRecordTimestamp = (aceRecord) => {
    aceRecord.timestamp = new Date(aceRecord.timestamp);
    return aceRecord;
};
const stream = (editor, callback) => {
    let running = true;
    let lastValue = editor.getValue();
    const changeListener = (delta) => {
        if (!running) {
            return;
        }
        if (editor.getValue() === lastValue) {
            return;
        }
        lastValue = editor.getValue();
        callback(Delta.check({ type: "delta", timestamp: new Date().toISOString(), focused: editor.isFocused(), ...delta }));
    };
    let lastSelection = Selection.check(editor.selection.getRange());
    const selectionListener = throttle(100, () => {
        if (!running) {
            return;
        }
        const selection = Selection.check(editor.selection.getRange());
        if (compareSelections(selection, lastSelection) || selectionIsEmpty(selection)) {
            return;
        }
        lastSelection = selection;
        callback(SelectionChange.check({
            type: "selectionchange",
            timestamp: new Date(),
            focused: editor.isFocused(),
            ...selection,
        }));
    });
    let lastCursor = EditorLocation.check(editor.selection.getCursor());
    const cursorListener = throttle(100, () => {
        if (!running) {
            return;
        }
        const cursor = EditorLocation.check(editor.selection.getCursor());
        if (compareEditorLocations(cursor, lastCursor) || !selectionIsEmpty(editor.selection.getRange())) {
            return;
        }
        lastCursor = cursor;
        callback(CursorChange.check({
            type: "cursorchange",
            timestamp: new Date(),
            focused: editor.isFocused(),
            location: cursor,
        }));
    });
    let lastScroll = ScrollPosition.check({ top: editor.renderer.getScrollTop(), left: editor.renderer.getScrollLeft() });
    const scrollListener = throttle(100, () => {
        if (!running) {
            return;
        }
        const scroll = ScrollPosition.check({ top: editor.renderer.getScrollTop(), left: editor.renderer.getScrollLeft() });
        if (scroll.top === lastScroll.top && scroll.left === lastScroll.left) {
            return;
        }
        lastScroll = scroll;
        callback(ScrollChange.check({
            type: "scrollchange",
            timestamp: new Date(),
            focused: editor.isFocused(),
            ...scroll,
        }));
    });
    editor.session.addEventListener("change", changeListener);
    editor.addEventListener("changeSelection", selectionListener);
    editor.addEventListener("changeSelection", cursorListener);
    editor.session.addEventListener("changeScrollTop", scrollListener);
    let restartTimer;
    const pause = () => {
        clearTimeout(restartTimer);
        running = false;
    };
    const restart = () => {
        restartTimer = setTimeout(() => {
            running = true;
        }, 200);
    };
    const stop = () => {
        clearTimeout(restartTimer);
        editor.session.removeEventListener("change", changeListener);
        editor.removeEventListener("changeSelection", selectionListener);
        editor.removeEventListener("changeSelection", cursorListener);
        editor.session.removeEventListener("changeScrollTop", scrollListener);
    };
    return { stop, pause, restart };
};
const record$1 = (editor, options = { interval: 1000 }) => {
    const interval = options.interval || 1000;
    const records = [getComplete(editor)];
    const { stop: cancel } = stream(editor, (record) => records.push(record));
    const timer = setInterval(() => records.push(getComplete(editor)), interval);
    const addExternalChange = (change) => {
        records.push(ExternalChange.check({ ...change, type: "external", timestamp: new Date() }));
    };
    const stop = () => {
        clearInterval(timer);
        cancel();
        records.push(getComplete(editor));
        return records;
    };
    return { stop, addExternalChange };
};
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const replay = (editor, trace, options = { start: 0 }) => {
    const replayer = {};
    let cancelled = false;
    replayer.promise = new Promise(async (resolve) => {
        const start = options.start || 0;
        const wasReadOnly = editor.getReadOnly();
        editor.setReadOnly(true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const renderer = editor.renderer;
        const wasVisible = renderer.$cursorLayer.isVisible;
        renderer.$cursorLayer.isVisible = true;
        const wasBlinking = renderer.$cursorLayer.isBlinking;
        renderer.$cursorLayer.setBlinking(true);
        const previousOpacity = renderer.$cursorLayer.element.style.opacity;
        renderer.$cursorLayer.element.style.opacity = 1;
        const startTime = new Date().valueOf();
        const traceStartTime = new Date(trace[0].timestamp).valueOf();
        let startIndex = 0;
        if (start > 0) {
            let i = 0;
            for (; i < trace.length; i++) {
                const record = trace[i];
                const currentTime = new Date(record.timestamp).valueOf() - traceStartTime;
                if (currentTime < start && Complete.guard(record)) {
                    startIndex = i;
                }
            }
        }
        for (let i = startIndex; i < trace.length && !cancelled; i++) {
            const aceRecord = trace[i];
            if (ExternalChange.guard(aceRecord) && options.onExternalChange) {
                options.onExternalChange(aceRecord);
            }
            else {
                applyAceRecord(editor, aceRecord);
            }
            if (trace[i + 1]) {
                const traceNextTime = new Date(trace[i + 1].timestamp).valueOf();
                const nextTime = startTime + (traceNextTime - (traceStartTime + start));
                const delay = nextTime - new Date().valueOf();
                if (delay > 0) {
                    await sleep(delay);
                }
            }
        }
        renderer.$cursorLayer.element.style.opacity = previousOpacity;
        renderer.$cursorLayer.setBlinking(wasBlinking);
        renderer.$cursorLayer.isVisible = wasVisible;
        editor.setReadOnly(wasReadOnly);
        resolve();
    });
    replayer.stop = () => {
        cancelled = true;
    };
    return replayer;
};
const safeChangeValue = (editor, value) => {
    const position = editor.session.selection.toJSON();
    editor.setValue(value);
    editor.session.selection.fromJSON(position);
};

exports.AceRecord = AceRecord;
exports.AceTimestamp = AceTimestamp;
exports.Complete = Complete;
exports.CursorChange = CursorChange;
exports.Delta = Delta;
exports.EditorLocation = EditorLocation;
exports.ExternalChange = ExternalChange;
exports.ScrollChange = ScrollChange;
exports.ScrollPosition = ScrollPosition;
exports.Selection = Selection;
exports.SelectionChange = SelectionChange;
exports.applyAceRecord = applyAceRecord;
exports.applyComplete = applyComplete;
exports.applyCursorChange = applyCursorChange;
exports.applyDelta = applyDelta;
exports.applyScrollChange = applyScrollChange;
exports.applySelectionChange = applySelectionChange;
exports.compareEditorLocations = compareEditorLocations;
exports.compareSelections = compareSelections;
exports.deserializeAceRecordTimestamp = deserializeAceRecordTimestamp;
exports.getComplete = getComplete;
exports.record = record$1;
exports.replay = replay;
exports.safeChangeValue = safeChangeValue;
exports.selectionIsEmpty = selectionIsEmpty;
exports.stream = stream;
//# sourceMappingURL=index.js.map
